import { Alert } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ConsentAlertProps {
    isConsentGiven: boolean;
}

export const ConsentAlert: React.FC<ConsentAlertProps> = ({ isConsentGiven }) => {
    const { t } = useTranslation();

    return isConsentGiven ? (
        <Alert severity='success'>{t('backgroundCheck.messages.consentProvided')}</Alert>
    ) : (
        <Alert severity='error'>{t('backgroundCheck.messages.hasNotConsented')}</Alert>
    );
};
